// Matches indexed legal and captures two groups so we can get the slug.
export const REGEX_INDEXED_LEGAL = /\${(LEGAL\.)(.+?)}/g;
// Matches indexed legal with entire legal key. ie. ${LEGAL.slug}
export const REGEX_INDEXED_LEGAL_WHOLE = /\${LEGAL\..+?}/g;
// Matches non-indexed legal and captures two groups so we can get the slug.
export const REGEX_NON_INDEXED_LEGAL = /\${(NONINDEX_LEGAL\.)(.+?)}/g;
